/**
 * @owner @Appboy/core-objects
 */
export const customObjectsTypeNameObjectIdUnlinkedObjects =
  "/data_objects/:type_name/:object_id/unlinked_objects" as const;
